module.exports = __webpack_public_path__ + "gq.24a34bb0338e843815cd.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/gq.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/gq.svg
// module chunks = styles